/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { useSessionStore } from 'store/session';
// Required import due to New React Scripts 5.0.0+
import { Buffer } from 'buffer';

const GRAPHQL_URL = import.meta.env.VITE_APP_BASE_GRAPHQL_URL ?? new URL('/graphql', window.location.toString()).href;

const httpLink = createHttpLink({
  uri: GRAPHQL_URL,
});

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const apiKey = useSessionStore.getState().apiKey ?? '';
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: `Basic ${Buffer.from(`InventoryLocation:${apiKey}`).toString('base64')}`,
    },
  };
});

export const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});
